// The number on the sidebar's Notifications row.
//
// Asked when the session starts and again whenever the window comes back into
// focus: a reminder that lands while somebody is in another tab should be
// waiting on the badge when they return, without the sidebar polling all day
// for the tabs nobody is looking at.
import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  clearUnreadNotificationCount,
  getUnreadNotificationCount,
  refreshUnreadNotificationCount,
  subscribeUnreadNotificationCount,
} from '../services/notificationCountStore';

export function useUnreadNotifications(): number {
  const { user } = useAuth();
  const authToken = user?.authToken;
  const [count, setCount] = useState<number>(getUnreadNotificationCount);

  useEffect(() => {
    const unsubscribe = subscribeUnreadNotificationCount(setCount);
    if (!authToken) {
      clearUnreadNotificationCount();
      return unsubscribe;
    }

    refreshUnreadNotificationCount();
    const onFocus = () => {
      refreshUnreadNotificationCount();
    };
    window.addEventListener('focus', onFocus);
    return () => {
      window.removeEventListener('focus', onFocus);
      unsubscribe();
    };
  }, [authToken]);

  return authToken ? count : 0;
}
